module.exports = __webpack_public_path__ + "img/file-icon_mp3.f1dfe91a.svg";